import {PROJECT_TAGS} from '@/constants';
import {PaymentLinkFlows} from '@/dataSource/src/api/payment-link/constants';
import {IEventBaseDataSchema} from '@/services/segment/models/TrackingManagerEventModel';

import {IPaymentLinkInformation} from '../entities';

export const buildPaymentLinkTrackingPayloadWithPaymentOption = (
  paymentInfo: IPaymentLinkInformation,
  amount: number,
  fee?: string,
  type?: string,
  prefill = false,
  receiverName?: string,
): IEventBaseDataSchema => {
  return {
    project_tag: PROJECT_TAGS.PAYMENT_LINK,
    ...(paymentInfo?.receiver_user?.id && {
      user: {id: paymentInfo?.receiver_user?.id},
    }),
    Fintech: {
      receiver: {
        user: {
          id: paymentInfo?.receiver_user?.id ?? '',
          name: receiverName ?? paymentInfo?.receiver_user?.name,
        },
      },
      transaction: {
        amount: amount?.toString(),
        fee: fee ?? '',
        method: type ?? '',
        prefill,
      },
    },
    Banking: {
      receiver: {
        user: {
          id: paymentInfo?.receiver_user?.id ?? '',
          name: receiverName ?? paymentInfo?.receiver_user?.name,
        },
      },
      transaction: {
        amount: amount?.toString(),
        fee: fee ?? '',
        method: type ?? '',
        prefill,
      },
    },
    Request: {
      payment_link: {
        id: paymentInfo?.id,
      },
      description: Boolean(paymentInfo.information?.note),
      gif: Boolean(paymentInfo.information?.gif),
      flow: paymentInfo.single_payment
        ? PaymentLinkFlows.LINK
        : PaymentLinkFlows.QR,
    },
  };
};
